import React from "react"
import PropTypes from "prop-types"
import { Box } from "@infotech/uikit-grid"
import styles from "./index.module.css"

// Подгоняет DataGrid под свою ширину и длину.
const DataGridContainer = ({ children, ...rest }) => (
  <Box flex column {...rest}>
    <Box grow={1} h="100%" style={{ position: `relative` }}>
      {children}
    </Box>
  </Box>
)

DataGridContainer.propTypes = {
  children: PropTypes.node,
}

DataGridContainer.defaultProps = {
  children: null,
}

export default DataGridContainer

// Класс для передачи в DataGrid
export const { wrappedDataGridStyle } = styles
